import type { ReactNode } from 'react'

interface ConditionalWrapperProps extends React.PropsWithChildren {
  when: boolean
  wrapper: (children: React.ReactNode) => React.ReactNode
}

// TODO: remove
export const ConditionalWrapper = ({
  when,
  wrapper,
  children,
}: ConditionalWrapperProps): ReactNode => (when ? wrapper(children) : children)
